import { Button, Icon, Box } from "@mui/material";
import { ExplainerTooltip } from "../../upgrades/ExplainerTooltip.js";

const UploadPhotoButton = ({ children, calendarId, handleImageUpload, ...props }) => (
  <Box sx={{ position: "absolute", top: "10px", right: "10px", display: "flex", alignItems: "center", gap: 0.5 }}>
    <Button
      variant="contained"
      size="small"
      startIcon={<Icon baseClassName="material-symbols-outlined" sx={{ fontSize: "1rem !important" }} >add_photo_alternate</Icon>}
      sx={{ backgroundColor: "#8E8E93", height: "24px", '.MuiButton-startIcon': { marginRight: "5px" } }}
      component="label"
      {...props}
    >
      Update Image <input type="file" accept="image/png, image/jpeg" hidden onChange={handleImageUpload} data-testid={`image-event-input-${calendarId}`} />{" "}
    </Button>
    <ExplainerTooltip 
      explainer="Recommended image size: 560×200px"
      placement="bottom"
      showArrow={false}
    >
      <Box
        sx={{
          backgroundColor: "#8E8E93",
          height: "24px",
          width: "24px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "help",
          "&:hover": {
            backgroundColor: "#7A7A80"
          }
        }}
      >
        <Icon
          baseClassName="material-symbols-outlined"
          sx={{
            fontSize: "0.9rem",
            color: "white"
          }}
        >
          info
        </Icon>
      </Box>
    </ExplainerTooltip>
  </Box>
)

export default UploadPhotoButton;